module.exports = __webpack_public_path__ + "img/app-mockup-heart-rate.e8a36584.png";